import * as Preact from 'preact';
import { Box } from '@mui/material';
import { isSmallScreen } from '../domain/theme/breakpoints';
import { useTheme } from '@mui/material/styles';
import { Dialog, Drawer } from '@mui/material';
import { RETURN_TO_STORE_HEIGHT } from '../M_ReturnToStoreBanner';
export var Component = function (props) {
    var _a;
    var isSmall = isSmallScreen(useTheme());
    return isSmall ? (Preact.h(Drawer, { anchor: 'bottom', open: props.open, PaperProps: { sx: { borderRadius: '10px 10px 0px 0px' } }, sx: { maxHeight: "calc(100% - ".concat(RETURN_TO_STORE_HEIGHT, ")"), height: 'max-content' } }, props.children)) : (Preact.h(Dialog, { open: props.open, BackdropProps: { style: { borderRadius: '24px', right: (_a = props.dialogPadding) !== null && _a !== void 0 ? _a : 0 } }, PaperProps: {
            sx: {
                borderRadius: '10px',
                margin: props.dialogPadding ? "0 ".concat(props.dialogPadding, " 0 0") : 0,
            },
        } },
        Preact.h(Box, { width: "390px" }, props.children)));
};
